import React from "react";

export default function MyDropdownButton({
  option,
}: {
  option: {
    heading: string;
    icon?: any;
    info: React.ReactNode;
  };
}) {
  return (
    <div className="">
      <div className="d-flex p-2 ">
        <div className="me-3">{option.icon && <option.icon width={35} />}</div>
        <div className=" d-flex flex-column align-items-start ms-3 text-wrap">
          <div className="">{option.info}</div>
        </div>
      </div>
    </div>
  );
}
